import timeFormAPI from '../../api/ui/timeFormAPI';
import {create} from './table-schema';
import useTranslation from '../../hooks/useTranslation';
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import changeNumApi from "../../api/ui/changeNumApi";
import {convertBigNumToDecimalString} from "../../utils/convert-decimal-to-big-num";

function useSchemaMonitoringTokenCC() {
    const {t} = useTranslation();
    const locale = useSelector((state) => state.language.locale);

    /**
     * 테이블 헤더에 표시할 항목 문자열 배열
     */
    const headerKeys = [
        "날짜",
        "ARB 가격",
        "PER 가격",
        "XPER 가격",
    ];

    /**
     * 서버로부터 전달받은 request를 테이블에 표시할 내용으로 변환한다.
     *
     * 오브젝트 키는 param1, param10 등의 형식으로 param 다음에 숫자를 붙여서 사용한다.
     *
     * param1은 헤더의 첫번째 표시되는 항목이다.
     *
     * 헤더에는 표시되지 않지만 상세에 표시될 항목의 경우 headSize 이후의 숫자를 사용한다.
     *
     * key는 반드시 있어야 한다.
     * @param {object} row
     * @returns
     */
    const parse = (row) => {

        const id = row?.index;

        const date = row["time"];
        const arb = row["ARB 가격"];
        const per = row["PER 가격"];
        const xper = row["XPER 가격"];


        return {
            key: id, // 키는 반드시 있어야 한다.
            param1: date,
            param2: arb,
            param3: per,
            param4: xper,
        };
    };

    /**
     * 로그 데이터를 클릭했을 때 보여줄 디테일 다이얼로그에 보여줄 항목을 작성한다.
     *
     * 입력값인 row는 위의 parse에서 변환된 값이다.
     *
     * @param {object} row
     * @returns
     */
    const details = (row) => {
        const array = [];
        if (row) {
            //
        }
        return array;
    };

    const [schema, setSchema] = useState();

    useEffect(() => {
        const headers = headerKeys.map((key) => t(key));
        const schema = create({
            heads: headers,
            parseFunc: parse,
            detailFunc: details,
        });
        setSchema(schema);
    }, [locale]);

    return schema;
}

export default useSchemaMonitoringTokenCC;
